/**
 * Link collection filters.
 */

const link_collection_filters = (args) => {
    const id = args.id;
    const all_slug = id + '-' + args.all_slug;
    let store = args.store;
    let content = args.content;
    let carousel = args.carousel;
    let buttons = args.buttons;
    let has_not_been_rendered = true;

    if (
        !id ||
        !all_slug ||
        !store ||
        (!content && !carousel) ||
        !buttons.length ||
        buttons.length < 2
    ) {
        return;
    }

    function addLinksToCarousel(links) {
        // console.log('Adding links to carousel...');

        let list = carousel.querySelector('.splide__list');

        const id = carousel.getAttribute('data-carousel-id');

        // If the carousel has not been initialized
        if (typeof H_Tools?.carousel[id] === 'undefined') {
            list.innerHTML = links.join('');
        }

        // If the carousel has been initialized
        else {
            // Removing slides via Splide doesn't work, so clearing HTML instead
            list.innerHTML = '';

            // Add new slides
            H_Tools?.carousel[id].add(links);
        }
    }

    function getAnchor() {
        const currentUrl = document.URL,
            urlParts = currentUrl.split('#');

        return urlParts.length > 1 ? urlParts[1] : '';
    }

    function getValidTermSlugs(buttons) {
        let result = [];
        for (let i = 0; i < buttons.length; i++) {
            const slug = buttons[i].attributes
                .getNamedItem('href')
                .nodeValue.replace('#', '');
            if (slug !== all_slug) {
                result.push(slug);
            }
        }
        return result;
    }

    function inArray(needle, haystack) {
        let length = haystack.length;
        for (let i = 0; i < length; i++) {
            if (haystack[i] === needle) {
                return true;
            }
        }
        return false;
    }

    function getButtonSlug(button) {
        return button.getAttribute('href').replace('#', '');
    }

    function renderSingleTerm(slug) {
        // console.log('Rendering term ' + slug);

        // Update button states
        for (let i = 0; i < buttons.length; i++) {
            const button_slug = getButtonSlug(buttons[i]);
            if (button_slug === slug) {
                buttons[i].setAttribute('aria-current', 'true');
            } else {
                buttons[i].setAttribute('aria-current', 'false');
            }
        }

        // Update link collection content
        let links = [];
        for (let i = 0; i < store.children.length; i++) {
            // Skip children that don't have the 'data-terms' attribute
            const data_terms = store.children[i].getAttribute('data-terms');
            if (data_terms == null) {
                continue;
            }

            let link_terms = data_terms.split(' ');

            // Add link collection id as suffix
            link_terms = link_terms.map((term) => id + '-' + term);

            // console.log(link_terms);

            if (inArray(slug, link_terms)) {
                links.push(store.children[i].outerHTML);
            }
        }

        if (carousel) {
            addLinksToCarousel(links);
        } else {
            content.innerHTML = links.join('');
        }

        // Make inserted content backwards focusable
        H_Tools?.stickyheader?.makeBackwardsFocusable(content);

        // Enable dictionary entries in inserted content
        H_Tools?.dictionary?.enableDictionaryEntries(content);

        // Enable accordions
        H_Tools?.accordions?.enableAccordions(content);

        has_not_been_rendered = false;
    }

    function renderFirstTerm() {
        // console.log('Rendering all items for ' + id);
        const first_item_slug = getButtonSlug(buttons[0]);
        renderSingleTerm(first_item_slug);
    }

    function renderCurrentSelection() {
        const current_slug = getAnchor();

        // console.log('Slug changed to #' + current_slug + ' (' + id + ')');

        if (!current_slug.startsWith(id)) {
            if (has_not_been_rendered) {
                renderFirstTerm();
            }
            return;
        }

        // console.log('Rendering current slug #' + current_slug + ' for ' + id);

        const valid_term_slugs = getValidTermSlugs(buttons);

        // console.log(valid_term_slugs);

        if (inArray(current_slug, valid_term_slugs)) {
            renderSingleTerm(current_slug);
        } else {
            renderFirstTerm();
        }
    }

    addEventListener('hashchange', (e) => {
        renderCurrentSelection();
    });

    renderCurrentSelection();
};

document
    .querySelectorAll('.js-link-collection.-filtered')
    .forEach((link_collection) => {
        let all_slug = link_collection.getAttribute('data-all-slug');
        if (all_slug == null) {
            all_slug = 'all';
        }
        link_collection_filters({
            id: link_collection.id,
            all_slug: all_slug,
            store: link_collection.querySelector(
                '.js-link-collection-link-store'
            ),
            content: link_collection.querySelector(
                '.js-link-collection-content'
            ),
            carousel: link_collection.querySelector(
                '.js-link-collection-carousel'
            ),
            buttons: link_collection.querySelectorAll(
                '.js-link-collection-filter-button'
            ),
        });
    });
